import React from 'react';
import {Container, Row, Col} from "react-bootstrap";
import {Link} from 'gatsby';


function Readybuild(props) {
    return (
        <section className="p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Core Business">
                            <h2>Streamline Your Core Business Operations With TekRevol’s Oracle Cloud</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>As a certified Oracle Cloud partner, TekRevol helps clients and partners build
                            fully-functional cloud application architecture. Our Oracle consultation services are
                            designed to reduce the operational costs of businesses while providing a faster and more
                            secure connection to access data from anywhere.</p>
                        <p>With our Oracle consulting services, you maximize productivity, mitigate cost, strengthen
                            security, reduce errors and operational flaws, increase agility, and access emerging cloud
                            technologies to transform your business to the next level.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Readybuild;